import React from 'react';
import { useAtomValue } from 'jotai';
import { teamsAtom, turnAtom, languageAtom } from '../GlobalState';
import { Center, Text3D } from '@react-three/drei';
import BackdoToken from '../moveTokens/BackdoToken';
import DoToken from '../moveTokens/DoToken';
import GeToken from '../moveTokens/GeToken';
import YootToken from '../moveTokens/YootToken';
import MoToken from '../moveTokens/MoToken';
import GulToken from '../moveTokens/GulToken';
import Rocket from '../meshes/Rocket';
import Ufo from '../meshes/Ufo';
import translations from '../dictionaries/translations';

export default function MoveList({ position, rotation, tokenScale, tokenPosition, size, piecePosition, pieceScale, gamePhase }) {
    const teams = useAtomValue(teamsAtom)
    const turn = useAtomValue(turnAtom)
    const moves = teams[turn.team].moves
    const moveList = movesToArray()
    const language = useAtomValue(languageAtom)

    function movesToArray() {
      const moveList = []
      for (const move in moves) {
        if (move !== '0') {
          for (let i = 0; i < moves[move]; i++) {
            moveList.push(move)
          }
        }
      }
      return moveList
    }
    
    return <group position={position}>
      <Text3D
      font={language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json"}
      rotation={rotation} 
      size={size}
      height={0.03}>
        {translations.game.moves[language]}
        <meshStandardMaterial color='yellow'/>
      </Text3D>
      <group position={language === 'korean' ? [-0.55, 0, 0.1] : [0,0,0]}>
        { turn.team === 0 && <Rocket position={piecePosition} scale={pieceScale}/>}
        { turn.team === 1 && <Ufo position={piecePosition} scale={pieceScale}/>}
      </group>
      { gamePhase === 'game' && moveList.map((value, index) => 
        <group key={index}>
          {value === '-1' && <BackdoToken position={[index*0.8-0.2 + tokenPosition[0], tokenPosition[1], tokenPosition[2]]} rotation={[0, Math.PI/2, 0]} scale={tokenScale}/>}
          {value === '1' && <DoToken position={[index*0.8-0.2 + tokenPosition[0], tokenPosition[1], tokenPosition[2]]} rotation={[0, Math.PI/2, 0]} scale={tokenScale}/>}
          {value === '2' && <GeToken position={[index*0.8-0.2 + tokenPosition[0], tokenPosition[1], tokenPosition[2]]} rotation={[0, Math.PI/2, 0]} scale={tokenScale}/>}
          {value === '3' && <GulToken position={[index*0.8-0.2 + tokenPosition[0], tokenPosition[1], tokenPosition[2]]} rotation={[0, Math.PI/2, 0]} scale={tokenScale}/>}
          {value === '4' && <YootToken position={[index*0.8-0.2 + tokenPosition[0], tokenPosition[1], tokenPosition[2]]} rotation={[0, Math.PI/2, 0]} scale={tokenScale}/>}
          {value === '5' && <MoToken position={[index*0.8-0.2 + tokenPosition[0], tokenPosition[1], tokenPosition[2]]} rotation={[0, Math.PI/2, 0]} scale={tokenScale}/>}
        </group>
      )}
      { gamePhase === 'pregame' && <Center position={[0, 0, 0.5]} right key={Math.random()}>
        <Text3D
          font={language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json"}
          rotation={[-Math.PI/2, 0, 0]}
          size={size}
          height={0.01}
        >
          {translations.game.pregame[language]}
          <meshStandardMaterial color='limegreen'/>
        </Text3D>
      </Center> }
    </group>
}